import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "register"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "form"
};
var _hoisted_4 = {
  class: "tip"
};
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import { computed, ref } from "vue";
import FormItem from "./form/FormItem.vue";
import { isPhoneAccount } from "./helper";
import { mobileRegister } from "@/api/user";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { Notify } from "@/utils/notifyUtil";
import { nextTick } from "vue";
import { CODE_INVALID, PHONE_REGISTER, CODE_ERROR } from "@/constant/responseCode";
import { getSupplyId } from "@/utils/authUtil";
import { useSupplierStore } from "@/store/supplierStore";
import md5 from "js-md5";
import { useShopStore } from "@/store/shopStore";
import { useI18n } from "vue-i18n";
import { PopupPageKey } from "@/constant/pageKey";
export default {
  __name: 'MobileRegisterPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var shopStore = useShopStore();
    var emit = __emit;
    var isDisabled = computed(function () {
      return !formData.value.name || !formData.value.calling_code || !formData.value.phone || !formData.value.password || !formData.value.confirm_password || supplierStore.getIsSMSOpen && !formData.value.code;
    });
    var formData = ref({
      name: "",
      phone: "",
      password: "",
      confirm_password: "",
      calling_code: "",
      code: "",
      birthday: 0
    });
    var errorForm = ref({
      phone: "",
      password: "",
      confirm_password: ""
    });
    var props = __props;
    var checkParams = function checkParams() {
      var flag = true;
      if (!isPhoneAccount(formData.value.phone, formData.value.calling_code)) {
        errorForm.value.phone = t("wrongFormatOfPhoneNumber");
        flag = false;
      }
      if (formData.value.password.length < 6) {
        errorForm.value.password = t("atLeast6Characters");
        flag = false;
      }
      if (formData.value.confirm_password.length < 6) {
        errorForm.value.confirm_password = t("atLeast6Characters");
        flag = false;
      }
      if (formData.value.confirm_password !== formData.value.password) {
        if (!errorForm.value.password) errorForm.value.password = t("theEnteredPasswordsDoNotMatch");
        if (!errorForm.value.confirm_password) errorForm.value.confirm_password = t("theEnteredPasswordsDoNotMatch");
        flag = false;
      }
      if (flag) {
        errorForm.value.phone = "";
        errorForm.value.password = "";
        errorForm.value.confirm_password = "";
      }
      return flag;
    };
    var submit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (checkParams()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              showLoading();
              _context.next = 5;
              return mobileRegister({
                supplier_id: getSupplyId(),
                nickname: formData.value.name,
                phone: formData.value.phone,
                area_code: formData.value.calling_code,
                password: md5(formData.value.password),
                verification_code: formData.value.code,
                country: supplierStore.getCountry,
                shop_id: shopStore.getShopId,
                birthday: formData.value.birthday
              });
            case 5:
              res = _context.sent;
              hideLoading();
              if (res.isOK) {
                Notify.success(t("registrationSuccess"));
                emit("success", formData.value.calling_code, formData.value.phone);
                showPopup.value = false;
                nextTick(function () {
                  formData.value.name = "";
                  formData.value.phone = "";
                  formData.value.password = "";
                  formData.value.confirm_password = "";
                  formData.value.code = "";
                  formData.value.birthday = 0;
                });
              } else if (res.code === CODE_INVALID || res.code === CODE_ERROR) {
                hideLoading();
                Notify.error(t("verificationCodeIsInvalid"));
              } else if (res.code === PHONE_REGISTER) {
                hideLoading();
                Notify.error(t("phoneNumberHasBeenRegistered"));
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submit() {
        return _ref2.apply(this, arguments);
      };
    }();
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createBlock(PagePopupLayout, {
        show: showPopup.value,
        "onUpdate:show": _cache[12] || (_cache[12] = function ($event) {
          return showPopup.value = $event;
        }),
        "content-class": "register-container",
        "page-key": _unref(PopupPageKey).MOBILE_REGISTER
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("register")), 1), _createElementVNode("form", _hoisted_3, [_createVNode(FormItem, {
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return formData.value.name = $event;
            }),
            placeholder: _ctx.$t('pleaseEnterYourNickname1To20'),
            label: _ctx.$t('name'),
            maxlength: "20",
            clearable: ""
          }, null, 8, ["modelValue", "placeholder", "label"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _createVNode(FormItem, {
            callcode: formData.value.calling_code,
            "onUpdate:callcode": _cache[1] || (_cache[1] = function ($event) {
              return formData.value.calling_code = $event;
            }),
            modelValue: formData.value.phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return formData.value.phone = $event;
            }),
            label: _ctx.$t('phone'),
            type: "phone",
            error: errorForm.value.phone,
            onInput: _cache[3] || (_cache[3] = function ($event) {
              return errorForm.value.phone = '';
            })
          }, null, 8, ["callcode", "modelValue", "label", "error"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _createVNode(FormItem, {
            modelValue: formData.value.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return formData.value.password = $event;
            }),
            label: _ctx.$t('password'),
            type: "password",
            error: errorForm.value.password,
            onInput: _cache[5] || (_cache[5] = function ($event) {
              return errorForm.value.password = '';
            })
          }, null, 8, ["modelValue", "label", "error"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _createVNode(FormItem, {
            modelValue: formData.value.confirm_password,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return formData.value.confirm_password = $event;
            }),
            label: _ctx.$t('confirmPassword'),
            type: "password",
            error: errorForm.value.confirm_password,
            onInput: _cache[7] || (_cache[7] = function ($event) {
              return errorForm.value.confirm_password = '';
            })
          }, null, 8, ["modelValue", "label", "error"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _createVNode(FormItem, {
            birthday: formData.value.birthday,
            "onUpdate:birthday": _cache[8] || (_cache[8] = function ($event) {
              return formData.value.birthday = $event;
            }),
            label: _ctx.$t('birthday'),
            type: "birthday",
            "label-desc": _ctx.$t('optional')
          }, null, 8, ["birthday", "label", "label-desc"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _unref(supplierStore).getIsSMSOpen ? (_openBlock(), _createBlock(FormItem, {
            key: 0,
            modelValue: formData.value.code,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
              return formData.value.code = $event;
            }),
            phone: formData.value.phone,
            callcode: formData.value.calling_code,
            operation: "Register",
            label: _ctx.$t('vertificationCode'),
            type: "reg",
            "onPhone:error": _cache[10] || (_cache[10] = function ($event) {
              return errorForm.value.phone = _ctx.$t('wrongFormatOfPhoneNumber');
            })
          }, null, 8, ["modelValue", "phone", "callcode", "label"])) : _createCommentVNode("", true)]), _createVNode(_component_Button, {
            class: "btn",
            disabled: isDisabled.value,
            onClick: submit
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("register")), 1)];
            }),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(_ctx.$t("alreadyHaveAnAccount")) + " ", 1), _createElementVNode("span", {
            onClick: _cache[11] || (_cache[11] = function ($event) {
              return showPopup.value = false;
            })
          }, _toDisplayString(_ctx.$t("login")), 1)])])];
        }),
        _: 1
      }, 8, ["show", "page-key"]);
    };
  }
};